import React from 'react';

// Sticky tab strip for the device detail page.
//
// Active tab is driven by the URL hash (`#health`, `#apps`, …) so users can
// share/refresh and land on the same tab. The parent owns the active-tab
// string; we only render the buttons and call back when one is clicked.
//
// Visual language matches the top navbar: dark pill buttons with a subtle
// border, brand-pill fill for the active route. Keeps the dashboard
// chrome consistent end-to-end.

export const DEVICE_TABS = [
    { id: 'overview', label: 'Overview' },
    { id: 'license',  label: 'License'  },
    { id: 'controls', label: 'Controls' },
    { id: 'health',   label: 'Health'   },
    { id: 'hardware', label: 'Hardware' },
    { id: 'apps',     label: 'Apps'     },
    { id: 'network',  label: 'Network'  },
    { id: 'bluetooth', label: 'Bluetooth' },
    { id: 'location', label: 'Location' },
    { id: 'commands', label: 'Commands' },
    { id: 'logs',     label: 'Logs'     },
    { id: 'notes',    label: 'Notes'    },
];

export default function TabStrip({ activeTab, onTabChange }) {
    return (
        // top-[57px] = HeaderBar height. If the header grows we'll revisit.
        <div className="sticky top-[57px] z-20 bg-surface-page/95 backdrop-blur border-b border-white/[0.06]">
            <div className="px-6 py-3 flex gap-2 overflow-x-auto">
                {DEVICE_TABS.map(({ id, label }) => {
                    const isActive = activeTab === id;
                    return (
                        <button
                            key={id}
                            onClick={() => onTabChange(id)}
                            className={`inline-flex items-center px-3.5 py-1.5 rounded-lg text-sm font-medium border whitespace-nowrap transition-colors ${
                                isActive
                                    ? 'brand-pill'
                                    : 'bg-white/[0.02] border-white/[0.08] text-gray-300 hover:bg-white/[0.05] hover:border-white/[0.15]'
                            }`}
                        >
                            {label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
